var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75907 3.03625H12.2421C12.336 3.03624 12.4286 3.05845 12.5123 3.10107C12.5959 3.14368 12.6684 3.20549 12.7236 3.28145L14.9988 6.40948C15.0392 6.46513 15.0591 6.53309 15.0551 6.60177C15.0511 6.67046 15.0234 6.73563 14.9768 6.78619L8.219 14.1069C8.19114 14.137 8.15736 14.1611 8.11977 14.1775C8.08219 14.1939 8.04161 14.2024 8.00059 14.2024C7.95957 14.2024 7.91899 14.1939 7.8814 14.1775C7.84382 14.1611 7.81003 14.137 7.78217 14.1069L1.02443 6.78679C0.977619 6.73618 0.949834 6.67089 0.945818 6.60208C0.941802 6.53326 0.961803 6.46518 1.00241 6.40948L3.2776 3.28145C3.33282 3.20549 3.40523 3.14368 3.48891 3.10107C3.57259 3.05845 3.66516 3.03624 3.75907 3.03625Z",
    fill: "#A1A8B3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFund);
export default __webpack_public_path__ + "static/media/fund.292c5f4fc9dc2686389db2777345e23f.svg";
export { ForwardRef as ReactComponent };